const translations = {
  "topbar.InsuranceProducts": "Insurance Products",
  "topbar.OnlineServices": "Remote Services",
  //"topbar.OnlineServices": "Reimbursment and Referrals",
  "topbar.forYou": "Personal",
  "topbar.forBusiness": "Business",
  "topbar.forForeign": "For Foreign Citizens",
  "topbar.news": "News",
  "topbar.NewsAndBlogs": "News And Blog",
  "topbar.HealthInsurance": "Health Insurance",
  "topbar.autoInsurance": "Auto Insurance",
  "topbar.TravelInsurance": "Travel Insurance",
  "topbar.InsuranceAndMore": "Insurance & More",
  "topbar.ForForeignUsers": "Foreign Citizens",
  "topbar.ForeignStudentsInsurance":
    "Health insurance for international students",
  "topbar.InnerToursInsurance": "Inner Tours Insurance",
  "topbar.HealthCorpInsurance": "Corporate Health Insurance",
  "topbar.HealthIndividualInsurance": "Individual Health Insurance",
  "topbar.otherProducts": "Other Products",
  "topbar.ImedilBot": "Imedi L Bot",
  "topbar.FamilyReservationToDoc": "Appointment To Family Doctor",
  "topbar.InsideTravelInsurance": "Visitors",
  "main.ProductsAndServices": "Products and services",
  "main.Products": "Products",
  "main.offers": "Offers",
  "main.details": "In Detail",
  "main.newsAndBlog": "News",
  "main.seeAll": "See All",
  "main.distantCalls": "Remote referrals",
  "main.claimForReimbursement": "Claim for reimbursement",
  "main.hospitalGuarantee": "Inpatient Guarantee",
  "main.million": "Million",
  "footer.aboutUs": "About Us",
  "footer.career": "Career",
  "footer.financialData": "Financial information",
  "footer.moreAboutInsurance": "Learn more about insurance",
  "footer.offices": "Offices",
  "footer.feedback": "Feedback",
  "footer.address": "Tbilisi, Vazha-Pshavela Ave. 53a",
  "footer.ourTeam": "Our team",
  "footer.legalInformation": "Legal information",
  "footer.onlineCenter": "Online help",
  "footer.contact": "Contact",
  "footer.termsAndConditions": "Terms and Conditions",
  "footer.uno": "Uno / Uno+",
  "footer.unoActive": "Uno Active / Uno Active+",
  "footer.unoComfort": "Uno Comfort / Uno Comfort+",
  "footer.travelInsurance": "Travel Insurance",
  "footer.insuranceAndMore": "Insurance and More",
  "footer.newsAndBlogs": "News And Blogs",
  "footer.news": "News",
  "footer.healthAndInsurance": "Health and Insurance",
  "footer.company": "Company",
  "footer.contactUs": "Contact Us",
  "footer.healthInsurance": "Health Insurance",
  "footer.autoInsurance": "Auto Insurance",

  "topbar.myPolicy": "MY INSURANCE",
  "main.callUs": "Call Us",
  "main.messageUs": "Message Us",
  "main.aboutUs": "About Us",
  "main.moreAbout": "More about",

  "paymentResult.title": "Your request is processing",
  "paymentResult.parag": `Confirmation will be sent to you via SMS and the e-policy on the provided E-mail address.`,
  "topbar.uno": "Uno / Uno+",
  "topbar.unoActive": "Uno Active / Uno Active+",
  "topbar.unoComfort": "Uno Comfort / Uno Comfort+",
  "blogs.today": "Today",
};

export default translations;
